"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullish = exports.getCardNameAndLast4Digit = exports.getBase64Data = exports.excludeOnAccountPaymentType = exports.excludeOnAccountPaymentTypeSummary = exports.isDeselectDefaultOption = exports.generateDeselectDefaultOption = exports.filterEntityByStore = exports.convertAlphaNumbericToNumber = void 0;
const domain_1 = require("@oolio-group/domain");
function convertAlphaNumbericToNumber(value) {
    return +(value || '0').replace(/[^0-9]/g, '');
}
exports.convertAlphaNumbericToNumber = convertAlphaNumbericToNumber;
function filterEntityByStore(data, validatingStoreIds) {
    validatingStoreIds =
        typeof validatingStoreIds === 'string'
            ? [validatingStoreIds]
            : validatingStoreIds;
    return data.filter(item => {
        var _a;
        return Boolean(!validatingStoreIds ||
            ((_a = item === null || item === void 0 ? void 0 : item.stores) === null || _a === void 0 ? void 0 : _a.find(store => (store === null || store === void 0 ? void 0 : store.id) && validatingStoreIds.includes(store === null || store === void 0 ? void 0 : store.id))));
    });
}
exports.filterEntityByStore = filterEntityByStore;
function generateDeselectDefaultOption(optionName) {
    return `- ${optionName}`;
}
exports.generateDeselectDefaultOption = generateDeselectDefaultOption;
function isDeselectDefaultOption(optionName) {
    return (optionName === null || optionName === void 0 ? void 0 : optionName[0]) === '-';
}
exports.isDeselectDefaultOption = isDeselectDefaultOption;
function excludeOnAccountPaymentTypeSummary(payments, paymentTypes = []) {
    var _a;
    const onAccountPaymentId = (_a = paymentTypes === null || paymentTypes === void 0 ? void 0 : paymentTypes.find(payment => payment.name === domain_1.DefaultPaymentTypes.ON_ACCOUNT)) === null || _a === void 0 ? void 0 : _a.id;
    return payments.filter(p => {
        var _a;
        const paymentName = (_a = p.paymentType) === null || _a === void 0 ? void 0 : _a.name;
        return ((paymentName && paymentName !== domain_1.DefaultPaymentTypes.ON_ACCOUNT) ||
            (!paymentName && p.paymentType !== onAccountPaymentId));
    });
}
exports.excludeOnAccountPaymentTypeSummary = excludeOnAccountPaymentTypeSummary;
function excludeOnAccountPaymentType(payments) {
    return payments.filter(p => p.name !== domain_1.DefaultPaymentTypes.ON_ACCOUNT);
}
exports.excludeOnAccountPaymentType = excludeOnAccountPaymentType;
function getBase64Data(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = function (error) {
            reject(error);
        };
    });
}
exports.getBase64Data = getBase64Data;
const getCardNameAndLast4Digit = (payment) => {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const paymentReceipt = payment.paymentReceipt;
    const paymentName = (_a = payment.paymentType) === null || _a === void 0 ? void 0 : _a.name;
    let last4Digit = '';
    if (paymentName === domain_1.DefaultPaymentTypes.CARD && (paymentReceipt === null || paymentReceipt === void 0 ? void 0 : paymentReceipt.pan)) {
        last4Digit = ` (${(_b = paymentReceipt === null || paymentReceipt === void 0 ? void 0 : paymentReceipt.pan.trim()) === null || _b === void 0 ? void 0 : _b.slice(-4)})`;
    }
    return paymentName + last4Digit;
};
exports.getCardNameAndLast4Digit = getCardNameAndLast4Digit;
// Checks if a value is null or undefined
function isNullish(value) {
    return value === null || value === undefined;
}
exports.isNullish = isNullish;
//# sourceMappingURL=common.js.map